import React from "react";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { StyledAuthSection } from "./styles";
import { useFormik } from "formik";
import { ChangePasswordValidationSchema } from "./helpers/schema";
import { useAuth } from "./hooks/useAuth";
const ChangePasswordFrom = ({ onPasswordUpdated }) => {
  const { isLoading, changePassword, isError: errorMessage } = useAuth();
  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      password: '',
      confirmPassword: ''
    },
    validationSchema: ChangePasswordValidationSchema,
    onSubmit: (values) => {
      changePassword(values.currentPassword, values.password).then((res) => {
        if (res && typeof res === "object" && res.StatusCode === 200) {
          onPasswordUpdated();
        }
      })
    }
  })
  const { currentPassword, confirmPassword, password } = formik.values;
  return (
    <StyledAuthSection className="tma_auth_content tma_changepass_content">
      <h1 className="tma_form_title">{translate("labels.changePassword")}</h1>
      <form className="tma_auth_form tma_changePass_form" onSubmit={formik.handleSubmit}>
        <div className="tma_form_control">
          <Input
            id="currentPassword"
            type="password"
            name="currentPassword"
            placeholder={'********'}
            labelText={translate('labels.currentPassword')}
            value={currentPassword}
            inputProps={{ maxLength: 100 }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.currentPassword &&
              Boolean(formik.errors.currentPassword)
            }
            helperText={
              formik.touched.currentPassword && formik.errors.currentPassword
            }
          />
        </div>
        <div className="tma_form_control">
          <Input
            id="password"
            type="password"
            name="password"
            placeholder={'********'}
            labelText={translate("labels.newPassword")}
            showInfoToolTip={false}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={password}
            inputProps={{ maxLength: 100 }}
            error={
              formik.touched.password &&
              Boolean(formik.errors.password)
            }
            helperText={
              formik.touched.password && formik.errors.password
            }
          />
        </div>
        <div className="tma_form_control">
          <Input
            id="confirmPassword"
            type="password"
            name="confirmPassword"
            placeholder={'********'}
            labelText={translate('labels.confirmPassword')}
            showInfoToolTip={false}
            value={confirmPassword}
            inputProps={{ maxLength: 100 }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmPassword &&
              Boolean(formik.errors.confirmPassword)
            }
            helperText={
              formik.touched.confirmPassword && formik.errors.confirmPassword
            }
          />
        </div>
        <div className="tma_form-feedback">
          {errorMessage && <p className="tma_error">{errorMessage}</p>}
        </div>
        <div className="tma_form_action">
          <Button text={translate('labels.changePassword')} type="submit" isLoading={isLoading} />
        </div>
      </form>
    </StyledAuthSection>
  );
};

export { ChangePasswordFrom };
